import { AsyncStateStatus } from '@sonar-software/xuder';
import { ConfirmDelete } from '@ui/modals';
import { createAsyncSelectors } from '@lib/selectors';
import { FullUserBoundary } from '@ui/general';
import { getQueryString } from '@sonar-software/sonar-http';
import { useNavigate } from 'react-router';
import { Button, Dropdown } from 'antd';
import { COPY_SPECIFIC, FULL_ROUTES, MESSAGES_COPY } from '@sonar-software/sonar-ts-constants';
import { coreActions, DataSecurityApplicationStatus, FeatureFlag } from '@sonar-software/sonar-core';
import React, { useCallback } from 'react';
import { useAction, useAsyncProcessing, useFeatureFlag } from '@hooks';
const detectedStatus = DataSecurityApplicationStatus[DataSecurityApplicationStatus.Detected].toLowerCase();
const hiddenStatus = DataSecurityApplicationStatus[DataSecurityApplicationStatus.Deleted].toLowerCase();
export const unhideApplicationSelectors = createAsyncSelectors((state) => state.core.dataSecurity.applications.unhide);
export const hideApplicationSelectors = createAsyncSelectors((state) => state.core.dataSecurity.applications.hide);
const dropdownButtonProps = {
    buttonsRender: ([leftButton, rightButton]) => [
        React.createElement("div", { key: 'leftButton' }, leftButton),
        React.createElement("div", { key: 'rightButton' },
            React.createElement(FullUserBoundary, null, rightButton))
    ],
    className: 'investigate-menu',
    placement: 'bottomRight'
};
export const DetectedApplicationActions = ({ applicationId, onStatusChange, status }) => {
    const navigate = useNavigate();
    const allowOverview = useFeatureFlag(FeatureFlag.DataSecurityDashboard);
    const hideApplication = useAction(coreActions.requestDeleteCoreDataSecurityApplications);
    const unhideApplication = useAction(coreActions.requestPatchCoreDataSecurityApplications);
    const resetHideApplication = useAction(coreActions.resetDeleteCoreDataSecurityApplications);
    const resetUnhideApplication = useAction(coreActions.resetPatchCoreDataSecurityApplications);
    const unhideProcess = useAsyncProcessing({
        resetAction: resetUnhideApplication,
        stateSelector: unhideApplicationSelectors.state,
        statusHandlers: {
            [AsyncStateStatus.Received]: () => onStatusChange(detectedStatus)
        }
    });
    const hideProcess = useAsyncProcessing({
        resetAction: resetHideApplication,
        stateSelector: hideApplicationSelectors.state,
        statusHandlers: {
            [AsyncStateStatus.Received]: () => onStatusChange(hiddenStatus)
        }
    });
    const handleUnhide = useCallback(() => {
        unhideProcess.watchNextCall();
        unhideApplication({ applicationId });
    }, [applicationId, unhideProcess, unhideApplication]);
    const handleHide = useCallback(() => {
        hideProcess.watchNextCall();
        hideApplication({ applicationId });
    }, [applicationId, hideProcess, hideApplication]);
    const isHidden = status === hiddenStatus;
    if (isHidden) {
        return (React.createElement(FullUserBoundary, null,
            React.createElement(Button, { onClick: handleUnhide, size: 'small' }, COPY_SPECIFIC.UNHIDE)));
    }
    const investigateButtonProps = {
        children: COPY_SPECIFIC.INVESTIGATE,
        onClick: () => navigate(`${FULL_ROUTES.DATA_SECURITY}/${applicationId}`)
    };
    const monitorEntry = {
        key: 'monitor',
        label: COPY_SPECIFIC.MONITOR_APP,
        onClick: () => navigate(`${FULL_ROUTES.ADD_APP}?${getQueryString({ applicationId })}`)
    };
    const hideEntry = {
        key: 'hide',
        label: React.createElement(ConfirmDelete, { className: 'confirm-hide', confirmButtonProps: {
                value: COPY_SPECIFIC.HIDE
            }, onConfirm: handleHide, title: MESSAGES_COPY.ARE_YOU_SURE_INTEGRATION_APP }, COPY_SPECIFIC.HIDE)
    };
    if (allowOverview) {
        return (React.createElement(Dropdown.Button, Object.assign({}, dropdownButtonProps, investigateButtonProps, { menu: {
                items: [monitorEntry, hideEntry]
            } })));
    }
    return (React.createElement(Dropdown.Button, Object.assign({}, dropdownButtonProps, { menu: {
            items: [hideEntry]
        }, onClick: monitorEntry.onClick }), monitorEntry.label));
};
